import Vue from "vue";
import Router from "vue-router";

const _import = require("./_import_" + process.env.NODE_ENV);
Vue.use(Router);

export default new Router({
  linkActiveClass: "router-link-active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  mode: process.env.VUE_APP_MODE, //history   hash
  routes: [
    { path: "/", name: "home_p", component: _import("PC/home/Home") },
    //关于我们
    {
      path: "/abountUs_p",
      name: "abountUs_p",
      component: _import("PC/abountUs/AbountUs"),
      redirect: { name: "overview_p" },
      children: [
        //  公司简介
        {
          path: "overview",
          name: "overview_p",
          component: _import("PC/abountUs/Overview")
        },
        // 企业文化
        {
          path: "culture",
          name: "culture_p",
          component: _import("PC/abountUs/Culture")
        },
        //公司优势
        {
          path: "advantage",
          name: "advantage_p",
          component: _import("PC/abountUs/Advantage")
        },
        // 人才队伍
        {
          path: "talentTeam",
          name: "talentTeam_p",
          component: _import("PC/abountUs/TalentTeam")
        },
        // 企业资质
        {
          path: "qualification",
          name: "qualification_p",
          component: _import("PC/abountUs/Qualification")
        }
      ]
    },
    // 核心能力
    {
      path: "/ability_p",
      name: "ability_p",
      component: _import("PC/ability/Index")
    },
    // 行业案例
    {
      path: "/businessCase_p",
      name: "businessCase_p",
      component: _import("PC/businessCase/BusinessCase")
    },
    // 联系我们
    {
      path: "/contactUs",
      name: "contactUs_p",
      component: _import("PC/contactUs/ContactUs")
    },
    // 合作伙伴
    {
      path: "/partners",
      name: "partners_p",
      component: _import("PC/partners/Partners")
    },
    // 人才招聘
    {
      path: "/recruitment",
      name: "recruitment_p",
      component: _import("PC/recruitment/Recruitment")
    },
    // 大事件新闻
    {
      path: "/news",
      name: "news_p",
      component: _import("PC/news/News"),
      redirect: { name: "newsList_p" },
      children: [
        {
          path: "newsList",
          name: "newsList_p",
          component: _import("PC/news/NewsList")
        },
        {
          path: "newsDetails",
          name: "newsDetails_p",
          component: _import("PC/news/NewsDetails")
        }
      ]
    },
    //  新闻搜索列表
    {
      path: "/search",
      name: "search_p",
      component: _import("PC/search/Search")
    },
    //移动端首页
    { path: "/home_m", name: "home_m", component: _import("Mobile/home/Home") },
    //移动端关于我们
    {
      path: "/abountUs",
      name: "abountUs_m",
      component: _import("Mobile/abountUs/AbountUs"),
      redirect: { name: "overview_m" },
      children: [
        //  公司简介
        {
          path: "overview",
          name: "overview_m",
          component: _import("Mobile/abountUs/Overview")
        },
        // 企业文化
        {
          path: "culture",
          name: "culture_m",
          component: _import("Mobile/abountUs/Culture")
        },
        //公司优势
        {
          path: "advantage",
          name: "advantage_m",
          component: _import("Mobile/abountUs/Advantage")
        },
        // 人才队伍
        {
          path: "talentTeam",
          name: "talentTeam_m",
          component: _import("Mobile/abountUs/TalentTeam")
        },
        // 企业资质
        {
          path: "qualification",
          name: "qualification_m",
          component: _import("Mobile/abountUs/Qualification")
        }
      ]
    },
    // 移动端核心能力
    {
      path: "/ability",
      name: "ability_m",
      component: _import("Mobile/ability/Index")
    },
    // 移动端行业案例
    {
      path: "/businessCase",
      name: "businessCase_m",
      component: _import("Mobile/businessCase/BusinessCase")
    },
    // 移动端联系我们
    {
      path: "/contactUs",
      name: "contactUs_m",
      component: _import("Mobile/contactUs/ContactUs")
    },
    // 移动端合作伙伴
    {
      path: "/partners",
      name: "partners_m",
      component: _import("Mobile/partners/Partners")
    },
    // 移动端人才招聘
    {
      path: "/recruitment",
      name: "recruitment_m",
      component: _import("Mobile/recruitment/Recruitment")
    },
    // 大事件新闻
    {
      path: "/news",
      name: "news_m",
      component: _import("Mobile/news/News"),
      redirect: { name: "newsList_m" },
      children: [
        {
          path: "newsList",
          name: "newsList_m",
          component: _import("Mobile/news/NewsList")
        },
        {
          path: "newsDetails",
          name: "newsDetails_m",
          component: _import("Mobile/news/NewsDetails")
        }
      ]
    },
    //  新闻搜索列表
    // {
    //   path: "/search",
    //   name: "search_p",
    //   component: _import("PC/search/Search")
    // }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js